module.exports = __webpack_public_path__ + "static/media/close-weiss_icn.1cbe222c.svg";